// extracted by mini-css-extract-plugin
export default {"breadcrumbsWrapper":"Kphbfh9fwjI0dzqeZ4UM","activeBreadcrumb":"PQag5z5v3C4NWzO3JKgp","disabled":"D4aRgfpCzAA6BtGB4Rlk"};